<template>
    <section id="content" class="gray-area">
        <div class="container">
            <!-- >>> 'BreadCrumbs' - Row -->
            <div class="row">
                <!-- >>> VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
                <sdr-breadcrumbs active_item="seventh" :module="modulo"></sdr-breadcrumbs>
                <!-- <<< VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
            </div>
            <!-- <<< 'BreadCrumbs' - Row -->



            <!-- >>> 'Confirmation' - Row -->
            <div class="row">
                <div class="container shortcode travel-ideas">
                    <h1 class="idea-title" style="margin-bottom:20px;"><span class="index"><i class="soap-icon-arrow-right circle"></i></span>{{ bookingconfirmation[getCurrentLocale] }}</h1>
                </div>

                <!-- >>>  Left Side: : 'Confirmation' -->
                <div id="main" class="col-sm-8 col-md-9">
                    <!-- >>> Payment Details -->
                    <div class="booking-information sdr-box" v-if="modulo === 'booking'">
                        <h2>{{ pleaseselectconfirmation[getCurrentLocale] }} {{ getBookingProcessBookingResults.bookingCode }}, {{ pleaseselectconfirmation2[getCurrentLocale] }} {{ getBookingProcessBookingResults.idInvoice }}</h2>
                        <hr />
                        <div class="booking-confirmation clearfix">
                            <i class="soap-icon-recommend icon circle"></i>
                            <div class="message">
                                <h4 class="main-message">{{ thankyou[getCurrentLocale] }}</h4>
                                <p>{{ emailhassent[getCurrentLocale] }}</p>
                            </div>
                            <!-- <a class="button btn-small print-button uppercase silver" style="cursor: initial; outline: none !important; outline-style: none !important;">{{ printdetails[getCurrentLocale] }}</a> -->
                        </div>
                        <hr />
                        <h2>{{ payment[getCurrentLocale] }}:</h2>
                        <dl class="term-description">
                            <dt>{{ payment_firstname[getCurrentLocale] }}:</dt><dd>{{ getBookingProcessBookingObject.customer.firstName }}</dd>
                            <dt>{{ payment_lastname[getCurrentLocale] }}:</dt><dd>{{ getBookingProcessBookingObject.customer.lastName }}</dd>
                            <dt>{{ payment_email[getCurrentLocale] }}:</dt><dd>{{ getBookingProcessBookingObject.customer.email }}</dd>
                            <dt>{{ payment_phone[getCurrentLocale] }}:</dt><dd>{{ getBookingProcessBookingObject.customer.phone }}</dd>
                            <dt>{{ payment_address[getCurrentLocale] }}:</dt><dd>{{ getBookingProcessBookingObject.customer.address }}</dd>
                            <dt>{{ payment_zipcode[getCurrentLocale] }}:</dt><dd>{{ getBookingProcessBookingObject.customer.zipCode }}</dd>
                            <dt>{{ payment_city[getCurrentLocale] }}:</dt><dd>{{ getBookingProcessBookingObject.customer.city }}</dd>
                            <dt>{{ payment_countrycode[getCurrentLocale] }}:</dt><dd>{{ getBookingProcessBookingObject.customer.countryCode }}</dd>
                        </dl>
                        <hr />
                        <h2>{{ paymentmethod[getCurrentLocale] }}:</h2>
                        <p>{{ forsecurity[getCurrentLocale] }}</p>
                        <br />
                        <p class="red-color" v-if="getBookingProcessBookingObject.payment.type !== 'OO'">
                            {{ paymentismadeby[getCurrentLocale] }}
                            {{ getBookingProcessBookingObject.payment.ccPayment !== null ? creditcard[getCurrentLocale] : null }}
                            {{ getBookingProcessBookingObject.payment.ddPayment !== null ? debit[getCurrentLocale] : null }}
                            {{ getBookingProcessBookingObject.payment.type === 'CS' ? cashpayment[getCurrentLocale] : null }}
                        .</p>
                    </div>

                    <div class="booking-information sdr-box" v-if="modulo === 'services'">
                        <h2>{{ pleaseselectconfirmation[getCurrentLocale] }} {{ getServicesProcessBookingResults.newSpecialsResponse.invoice.bookingCode }}, {{ pleaseselectconfirmation2[getCurrentLocale] }} {{ getServicesProcessBookingResults.newSpecialsResponse.invoice.idInvoice }}</h2>
                        <hr />
                        <div class="booking-confirmation clearfix">
                            <i class="soap-icon-recommend icon circle"></i>
                            <div class="message">
                                <h4 class="main-message">{{ thankyou[getCurrentLocale] }}</h4>
                                <p>{{ emailhassent[getCurrentLocale] }}</p>
                            </div>
                            <!-- <a href="#" class="button btn-small print-button uppercase">{{ printdetails[getCurrentLocale] }}</a> -->
                        </div>
                        <hr />
                        <h2>{{ payment[getCurrentLocale] }}:</h2>
                        <dl class="term-description">
                            <dt>{{ payment_firstname[getCurrentLocale] }}:</dt><dd>{{ getServicesProcessBookingObject.customer.firstName }}</dd>
                            <dt>{{ payment_lastname[getCurrentLocale] }}:</dt><dd>{{ getServicesProcessBookingObject.customer.lastName }}</dd>
                            <dt>{{ payment_email[getCurrentLocale] }}:</dt><dd>{{ getServicesProcessBookingObject.customer.email }}</dd>
                            <dt>{{ payment_phone[getCurrentLocale] }}:</dt><dd>{{ getServicesProcessBookingObject.customer.phone }}</dd>
                            <dt>{{ payment_address[getCurrentLocale] }}:</dt><dd>{{ getServicesProcessBookingObject.customer.address }}</dd>
                            <dt>{{ payment_zipcode[getCurrentLocale] }}:</dt><dd>{{ getServicesProcessBookingObject.customer.zipCode }}</dd>
                            <dt>{{ payment_city[getCurrentLocale] }}:</dt><dd>{{ getServicesProcessBookingObject.customer.city }}</dd>
                            <dt>{{ payment_countrycode[getCurrentLocale] }}:</dt><dd>{{ getServicesProcessBookingObject.customer.countryCode }}</dd>
                        </dl>
                        <hr />
                        <h2>{{ paymentmethod[getCurrentLocale] }}:</h2>
                        <p>{{ forsecurity[getCurrentLocale] }}</p>
                        <br />
                        <p class="red-color" v-if="getServicesProcessBookingObject.payment.type !== 'OO'">
                            {{ paymentismadeby[getCurrentLocale] }}
                            {{ getServicesProcessBookingObject.payment.ccPayment !== undefined ? creditcard[getCurrentLocale] : null }}
                            {{ getServicesProcessBookingObject.payment.ddPayment !== undefined ? debit[getCurrentLocale] : null }}
                            {{ getServicesProcessBookingObject.payment.type === 'CS' ? cashpayment[getCurrentLocale] : null }}
                        .</p>
                    </div>

                    <div class="booking-information sdr-box" v-if="modulo === 'rebooking'">
                        <h2>{{ pleaseselectconfirmation[getCurrentLocale] }} {{ get_RebookingProcessRebookingResults.bookingCode }}, {{ pleaseselectconfirmation2[getCurrentLocale] }} {{ get_RebookingProcessRebookingResults.idInvoice }}</h2>
                        <hr />
                        <div class="booking-confirmation clearfix">
                            <i class="soap-icon-recommend icon circle"></i>
                            <div class="message">
                                <h4 class="main-message">{{ thankyou[getCurrentLocale] }}</h4>
                                <p>{{ emailhassent[getCurrentLocale] }}</p>
                            </div>
                            <!-- <a class="button btn-small print-button uppercase silver" style="cursor: initial; outline: none !important; outline-style: none !important;">{{ printdetails[getCurrentLocale] }}</a> -->
                        </div>
                        <hr />
                        <h2>{{ payment[getCurrentLocale] }}:</h2>
                        <dl class="term-description">
                            <dt>{{ payment_firstname[getCurrentLocale] }}:</dt><dd>{{ get_RebookingUsersSearchDataGetProcessRebooking.customer.firstName }}</dd>
                            <dt>{{ payment_lastname[getCurrentLocale] }}:</dt><dd>{{ get_RebookingUsersSearchDataGetProcessRebooking.customer.lastName }}</dd>
                            <dt>{{ payment_email[getCurrentLocale] }}:</dt><dd>{{ get_RebookingUsersSearchDataGetProcessRebooking.customer.email }}</dd>
                            <dt>{{ payment_phone[getCurrentLocale] }}:</dt><dd>{{ get_RebookingUsersSearchDataGetProcessRebooking.customer.phone }}</dd>
                            <dt>{{ payment_address[getCurrentLocale] }}:</dt><dd>{{ get_RebookingUsersSearchDataGetProcessRebooking.customer.address }}</dd>
                            <dt>{{ payment_zipcode[getCurrentLocale] }}:</dt><dd>{{ get_RebookingUsersSearchDataGetProcessRebooking.customer.zipCode }}</dd>
                            <dt>{{ payment_city[getCurrentLocale] }}:</dt><dd>{{ get_RebookingUsersSearchDataGetProcessRebooking.customer.city }}</dd>
                            <dt>{{ payment_countrycode[getCurrentLocale] }}:</dt><dd>{{ get_RebookingUsersSearchDataGetProcessRebooking.customer.countryCode }}</dd>
                        </dl>
                        <hr />
                        <h2>{{ paymentmethod[getCurrentLocale] }}:</h2>
                        <p>{{ forsecurity[getCurrentLocale] }}</p>
                        <br />
                        <p class="red-color" v-if="getBookingProcessBookingObject.payment.type !== 'OO'">
                            {{ paymentismadeby[getCurrentLocale] }}
                            {{ get_RebookingUsersSearchDataGetProcessRebooking.payment.ccPayment !== undefined ? creditcard[getCurrentLocale] : null }}
                            {{ get_RebookingUsersSearchDataGetProcessRebooking.payment.ddPayment !== undefined ? debit[getCurrentLocale] : null }}
                            {{ get_RebookingUsersSearchDataGetProcessRebooking.payment.type === 'CS' ? cashpayment[getCurrentLocale] : null }}
                        .</p>
                    </div>
                    <!-- >>> Payment Details -->



                    <!-- >>> Booking Details -->
                    <br />
                    <div id="flight-features" class="tab-container">
                        <!-- >>> TabHeader:  -->
                        <ul class="tabs">
                            <li class="active"><a href="#flight-details" data-toggle="tab">{{ tab_flightdetails[getCurrentLocale] }}</a></li>
                        </ul>
                        <!-- <<< TabHeader:  -->


                        <!-- >>> Tab Content: -->
                        <div class="tab-content">
                            <!-- --------------------------------------- -->
                            <!-- >>> Tab: 'flight-details' -->
                            <div class="tab-pane fade in active" id="flight-details">

                                <!-- >>> 'Outward Flight' -->
                                <div v-if="get_RebookingUsersSearchDataGetRebookingKey.idTicketOutwards.length > 0">
                                    <h2>{{ tab_header_flightdetailsoutward[getCurrentLocale] }}:</h2>
                                    <sdr-rebooking-bookingno-flightdetails :flight="get_RebookingGetRebookingKeyResults.outwardFlight" flightdirection="outward" :modulo="modulo" :mode="mode" whichcall="getrebookingkey"></sdr-rebooking-bookingno-flightdetails>
                                </div>
                                <!-- <<< 'Outward Flight' -->

                                <!-- >>> 'Inbound Flight' -->
                                <div v-if="get_RebookingUsersSearchDataGetRebookingKey.idTicketReturn.length > 0">
                                    <br /><hr style="border-top: 1px solid #fdb714;" /><br />
                                    <h2>{{ tab_header_flightdetailsreturn[getCurrentLocale] }}:</h2>
                                    <sdr-rebooking-bookingno-flightdetails :flight="get_RebookingGetRebookingKeyResults.inboundFlight" flightdirection="return" :modulo="modulo" :mode="mode" whichcall="getrebookingkey"></sdr-rebooking-bookingno-flightdetails>
                                </div>
                                <!-- <<< 'Inbound Flight' -->

                                <!-- >>> Total::Total::Total -->
                                <br />
                                <button class="btn-large full-width totalbutton" style="cursor: initial; background: #FDB714;">{{ get_RebookingProcessRebookingResultsTotal | rndAmntRUAFWZ }}<br />
                                    <span style="font-size: 0.5em;">{{ tincludedtaxes[getCurrentLocale] }}</span>
                                </button>
                                <!-- <<< Total::Total::Total -->
                            </div>
                            <!-- <<< Tab: 'flight-details' -->
                            <!-- --------------------------------------- -->
                        </div>
                        <!-- <<< Tab Content: -->
                    </div>
                    <!-- <<< Booking Details -->
                </div>
                <!-- <<<  Left Side: : 'Confirmation' -->



                <!-- >>>  Right Side: Sidebar, 'Confirmation' -->
                <div class="sidebar col-sms-6 col-sm-4 col-md-3">
                    <!-- >>> VueCmp - 'sdr-contact-box', 'Contact Box' -->
                    <sdr-contact-box></sdr-contact-box>
                    <!-- <<< VueCmp - 'sdr-contact-box', 'Contact Box' -->
                </div>
                <!-- <<<  Right Side: Sidebar, 'Confirmation' -->
            </div>
            <!-- <<< 'Confirmation' - Row -->
        </div>
    </section>
</template>

<script>
    import FlightDetails from '../../rebooking/pagecontent/BookingnoFlightDetails.vue';
    import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs.vue';
    import ContactBox from '../../shared/sidebar/ContactBox.vue';

    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'], // via: router/push
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-rebooking-bookingno-flightdetails': FlightDetails,
            'sdr-breadcrumbs': Breadcrumbs,
            'sdr-contact-box': ContactBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                pleaseselectconfirmation: {
                    en: 'Your booking code is',
                    de: 'Ihr Buchungscode lautet'
                },
                pleaseselectconfirmation2: {
                    en: 'Your Invoice-Id is:',
                    de: 'Ihre Rechnungsnummer ist:'
                },
                needhelp: {
                    en: 'Do you need any help?',
                    de: 'Brauchen Sie Hilfe?',
                },
                sideboxhelptext: {
                    en: 'We will be happy to help you. Our team consultants are at your disposal around the clock.',
                    de: 'Wir helfen Ihnen gerne weiter. Unsere Teamberater stehen Ihnen rund um die Uhr zur Verfügung.',
                },
                bookingconfirmation: {
                    en: 'Step 6: We confirm your booking!',
                    de: 'Schritt 6: Hiermit bestätigen wir Ihre Buchung!',
                },
                travelerinformation: {
                    en: 'Traveler Information',
                    de: 'Reisende Infos',
                },
                payment: {
                    en: 'Payment',
                    de: 'Zahlungsdetails',
                },
                viewbookingdetails: {
                    en: 'View Booking Details',
                    de: 'Ihre Buchungsdetails',
                },
                thankyou: {
                    en: 'Thank You. Your booking order is confirmed now.',
                    de: 'Vielen Dank. Ihre Buchungsanfrage ist hiermit bestätigt.',
                },
                emailhassent: {
                    en: 'A confirmation e-mail has been sent to your provided e-mail address.',
                    de: 'An Ihre angegebene E-Mail-Adresse wurde eine Bestätigungs-E-Mail gesendet.',
                },
                printdetails: {
                    en: 'Print Details',
                    de: 'Ausdrucken',
                },
                payment: {
                    en: 'Your Payment details',
                    de: 'Ihre Zahlungsdetails',
                },
                paymentmethod : {
                    en: 'Your Payment method',
                    de: 'Ihre Zahlungsmethode',
                },
                forsecurity: {
                    en: 'For security reasons we do not write out your complete payment data here.',
                    de: 'Aus Sicherheitsgründen schreiben wir hier Ihre kompletten Zahlungsdaten nicht aus.',
                },
                paymentismadeby : {
                    en: 'Payment is made by ',
                    de: 'Die Zahlung erfolgt durch ',
                },
                creditcard: {
                    en: 'Creditcard',
                    de: 'Kreditkarte',
                },
                debit: {
                    en: 'Direct Debit',
                    de: 'Überweisung',
                },
                cashpayment: {
                    en: 'Cash',
                    de: 'Barzahlung',
                },
                payment_firstname: {
                    en: 'FIRST NAME',
                    de: 'Vorname',
                },
                payment_lastname: {
                    en: 'LAST NAME',
                    de: 'Nachname',
                },
                payment_email: {
                    en: 'E-MAIL ADDRESS',
                    de: 'E-Mail',
                },
                payment_phone: {
                    en: 'Your Payment details',
                    de: 'Ihre Zahlungsdetails',
                },
                payment_address: {
                    en: 'STREET ADDRESS AND NUMBER',
                    de: 'Adresse',
                },
                payment_zipcode: {
                    en: 'ZIP CODE',
                    de: 'PLZ',
                },
                payment_city: {
                    en: 'TOWN / CITY',
                    de: 'Wohnort',
                },
                payment_countrycode: {
                    en: 'COUNTRY',
                    de: 'Land',
                },
                tab_flightdetails: {
                    en: 'Flight/Service Details',
                    de: 'Flug/Service Details'
                },
                flightpriceservices: {
                    en: 'Flight already booked',
                    de: 'Flug schon gebucht',
                },
                tincludedtaxes: {
                    en: 'incl. Taxes, Fees & Surcharges',
                    de: 'inkl. Steuern, Gebühren & Zuschlägen',
                },
                // >>> --------------------------
                seat: {
                    en: 'Seat',
                    de: 'Sitz',
                },
                // >>> --------------------------
                alertsuccessful: {
                    en: 'Successful!',
                    de: 'Erfolgreich!',
                },
                alertyourbooking: {
                    en: 'Your booking has been made.',
                    de: 'Ihre Buchung ist erfolgt.',
                },
                // >>> --------------------------
                tab_header_flightdetailsoutward: {
                    en: 'Your flight and booking details for all outbound flights',
                    de: 'Ihre Flug- und Buchungsdetails zu allen Hinflügen'
                },
                tab_header_flightdetailsreturn: {
                    en: 'Your flight and booking details for all return flights',
                    de: 'Ihre Flug- und Buchungsdetails zu allen Rückflugen'
                },
                // currentLocale: 'de',
            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                // >>> --------------------------
                'getBookingProcessBookingObject',
                'getBookingProcessBookingResults',
                'getBookingFlightIdSelectedReturn', // got RET Flight?
                'getBookingCartOutwardTotal', // Summed up Outward ALL
                'getBookingCartReturnTotal', // Summed up Return ALL
                // >>> --------------------------
                'getServicesProcessBookingObject',
                'getServicesProcessBookingResults',
                // >>> --------------------------
                'get_areWeInServicesBookingNoMode',
                // >>> --------------------------
                'get_RebookingProcessRebookingResults',
                'get_RebookingUsersSearchDataGetProcessRebooking',
                'get_RebookingUsersSearchDataGetRebookingKey',
                'get_RebookingGetRebookingKeyResults',
                'get_RebookingProcessRebookingResultsTotal',
            ]),

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function() {

            this.$swal(this.alertsuccessful[this.getCurrentLocale], this.alertyourbooking[this.getCurrentLocale], "success");

        }, // eo mounted
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .booking-information > .booking-confirmation .main-message {
        color: #9F4378;
    }

    dl.term-description dt {
        color: #9e4d84;
    }

    .totalbutton {
        padding-right: 7px;
        height: 43px;
        font-size: 1.6667em; /* 1.4167em, 1.1667em; 1.6667em */
        line-height: 15px;
        text-align: right;
        height: 57px;
    }

    .swal-button {
        padding: 0px !important;
    }





    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.5em;
        }
        h2 {
            font-size: 1.4em;
        }
        button.btn-large, input[type="button"].button.btn-large, a.button.btn-large {
            font-size: 1.0em;
        }

        .booking-information {
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 20px;
            padding-left: 15px;
        }
    }
</style>